import React from "react";
import {Route, Switch} from "react-router-dom";
import Account from "./pages/Account";
import Operator from './pages/operator'
import Accountmanagement from "./pages/accountmanagement";
import Monthlyprice from "./pages/monthlyprice";
import Administratoraccount from "./pages/administrationaccount"
import NotFound from './NotFound';
import AuthenticatedRoute from "./auth/AuthenticatedRoute";
import CheckAuth from "./auth/CheckAuth";
import MaintenancePage from "./MaintenancePage"
import SupplyCatalog from "./pages/SupplyCatalog";
import SWCatalogupload from "./pages/SWCatalogUpload";
import HoneyBeeLandingPage from "./pages/HoneyBeeLandingPage";
import SWDownload from "./pages/SWDownload";
import CLILandingPage from "./pages/CLILandingPage";

const Body = (props) => {
    return (
        <div className="Body">
            {props.maintenanceMode ?
                <Switch> <Route path="/" component={MaintenancePage}/> </Switch> :
                <Switch>
                    <AuthenticatedRoute exact path="/" name="home" authenticated={props.authenticated} role={props.role}
                                        businessId={props.businessId} component={CheckAuth}/>
                    <Route exact path="/supply-encoding" component={CheckAuth}/>
                    <AuthenticatedRoute exact path="/account" name="account" authenticated={props.authenticated}
                                        role={props.role} component={Account} businessId={props.businessId}/>
                    <AuthenticatedRoute exact path="/sw-download" name="sw-download" authenticated={props.authenticated}
                                        role={props.role} component={SWDownload}/>
                    <AuthenticatedRoute exact path="/operator" name="operator" authenticated={props.authenticated}
                                        role={props.role} businessId={props.businessId} component={Operator}/>
                    <Route exact path="/sps-account" component={CheckAuth}/>
                    <AuthenticatedRoute exact path="/sps-supply-catalog" name="sps-supply-catalog"
                                        authenticated={props.authenticated} role={props.role}
                                        component={SupplyCatalog}/>
                    <AuthenticatedRoute exact path="/sw-catalog" name="sw-catalog" authenticated={props.authenticated}
                                        role={props.role} component={SWCatalogupload}/>
                    <AuthenticatedRoute exact path="/sps-account-home" name="sps-account-home"
                                        authenticated={props.authenticated} role={props.role}
                                        component={Accountmanagement}/>
                    <AuthenticatedRoute exact path="/sps-admin" name="sps-admin" authenticated={props.authenticated}
                                        role={props.role} component={Administratoraccount}/>
                    <AuthenticatedRoute exact path="/sps-monthlyprice" name="sps-monthlyprice"
                                        authenticated={props.authenticated} role={props.role} component={Monthlyprice}/>
                    <Route exact path="/cli" component={CLILandingPage}/>
                    <Route component={NotFound}/>
                </Switch>
            }
        </div>
    )
}
export default Body
